import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { PUT_URL } from '@utils/api/endpoints.ts';

interface UpdateCommentParams {
  session_id: string;
  document_id: string;
  comment_id: string;
  payload: {
    text: string;
    index_from: string;
    index_to: string;
  };
}

export const useUpdateComment = () => {
  const queryClient = useQueryClient();

  const updateComment = async ({
    session_id,
    document_id,
    comment_id,
    payload
  }: UpdateCommentParams) => {
    const url = PUT_URL(session_id, document_id, comment_id).updateComment;
    const response = await Axios.put(url, payload);
    return response.data;
  };

  return useMutation(updateComment, {
    onSuccess: () => {
      queryClient.invalidateQueries(['comments']);
    }
  });
};
